import React, { useEffect, useState } from 'react';
import { Snackbar, Button } from '@mui/material';
import { useLanguage } from 'Context/LanguageContext';


const POLL_INTERVAL = 12 * 60 * 60 * 1000; // 12 horas

const VersionChecker = () => {
  const [open, setOpen] = useState(false);
  const [latestVersion, setLatestVersion] = useState(null);
  const lan = useLanguage();
  

  const checkVersion = async () => {
    try {
      const baseUrl = window.location.origin;
      const res = await fetch(`${baseUrl}/meta.json`, { cache: 'no-store' });

      if (!res.ok) throw new Error(`HTTP error: ${res.status}`);

      const { version } = await res.json();
      const currentVersion = localStorage.getItem('app_version');

      if (currentVersion && currentVersion !== version) {
        setLatestVersion(version);
        setOpen(true);
      } else if (!currentVersion) {
        localStorage.setItem('app_version', version);
      }
    } catch (e) {
      console.error('Error al verificar la versión', e);
    }
  };

  const handleReload = () => {
    localStorage.setItem('app_version', latestVersion);
    window.location.reload();
  };

  useEffect(() => {
    checkVersion();
    const interval = setInterval(checkVersion, POLL_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  return (
    <Snackbar
      open={open}
      message={lan.newVersionAvailable}
      action={
        <Button
          size="small"
          onClick={handleReload}
          sx={{ color: '#dc5c87' }}
        >
          {lan.update}
        </Button>
      }
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    />
  );
};

export default VersionChecker;
